////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const telecollectManager = {
	getTelecollects: (filters = {}, queryParams = { page: '0', size: '250', sort: 'date', nameDir: 'desc' }) => ({
		type: ActionsTypes.GET_TELECOLLECTS,
		payload: {
			filters,
			queryParams,
		},
	}),
	getTelecollectsSuccess: (data) => ({
		type: ActionsTypes.GET_TELECOLLECTS_SUCCESS,
		payload: {
			data,
		},
	}),
	getTelecollectsFailure: (error) => ({
		type: ActionsTypes.GET_TELECOLLECTS_FAILURE,
		payload: {
			error,
		},
	}),
	getDetailHeader: (idTelecollect, bodyMsg) => ({
		type: ActionsTypes.GET_TELECOLLECT_HEADER,
		payload: { idTelecollect, bodyMsg },
	}),
	getDetailHeaderSuccess: (telecollectHeader) => ({
		type: ActionsTypes.GET_TELECOLLECT_HEADER_SUCCESS,
		payload: {
			telecollectHeader,
		},
	}),
	getDetailHeaderFailure: (error) => ({
		type: ActionsTypes.GET_TELECOLLECT_HEADER_FAILURE,
		payload: {
			error,
		},
	}),
	getDetailItems: (idTelecollect, filters = {}, mode) => ({
		type: ActionsTypes.GET_TELECOLLECT_DETAIL_ITEMS,
		payload: {
			idTelecollect,
			filters,
			mode,
		},
	}),
	getDetailItemsSuccess: (data, mode) => ({
		type: ActionsTypes.GET_TELECOLLECT_DETAIL_ITEMS_SUCCESS,
		payload: {
			data,
			mode,
		},
	}),
	getDetailItemsFailure: (error) => ({
		type: ActionsTypes.GET_TELECOLLECT_DETAIL_ITEMS_FAILURE,
		payload: {
			error,
		},
	}),
	getDetailSale: (idTelecollect, idSale, filters = {}) => ({
		type: ActionsTypes.GET_TELECOLLECT_DETAIL_SALE,
		payload: {
			idTelecollect,
			idSale,
			filters,
		},
	}),
	getDetailSaleSuccess: (data) => ({
		type: ActionsTypes.GET_TELECOLLECT_DETAIL_SALE_SUCCESS,
		payload: {
			data,
		},
	}),
	getDetailSaleFailure: (error) => ({
		type: ActionsTypes.GET_TELECOLLECT_DETAIL_SALE_FAILURE,
		payload: {
			error,
		},
	}),
	setTelecollectComparison: (idTelecollect, filters = {}) => ({
		type: ActionsTypes.SET_TELECOLLECT_COMPARISON,
		payload: {
			idTelecollect,
			filters,
		},
	}),
	setTelecollectComparisonSuccess: (data) => ({
		type: ActionsTypes.SET_TELECOLLECT_COMPARISON_SUCCESS,
		payload: {
			data,
		},
	}),
	setTelecollectComparisonFailure: (error) => ({
		type: ActionsTypes.SET_TELECOLLECT_COMPARISON_FAILURE,
		payload: {
			error,
		},
	}),
	resetTelecollectItems: () => ({
		type: ActionsTypes.RESET_TELECOLLECT_ITEMS,
	}),
	getTelecollectTicket: (idTelecollect) => ({
		type: ActionsTypes.GET_TELECOLLECT_TICKET,
		payload: { idTelecollect },
	}),
	getTelecollectTicketSuccess: (data) => ({
		type: ActionsTypes.GET_TELECOLLECT_TICKET_SUCCESS,
		payload: {
			data,
		},
	}),
	getTelecollectTicketFailure: (error) => ({
		type: ActionsTypes.GET_TELECOLLECT_TICKET_FAILURE,
		payload: {
			error,
		},
	}),
}

export default telecollectManager
